import React, { useEffect, useRef, useState } from 'react';
import { ActionButton } from '../ActionButton';
import styles from './styles.module.scss';

interface MessageModalProps {
  show: boolean;
  onClose: () => void;
  title: string;
  description: string;
  detail?: string;
  action: () => void;
  'data-testid'?: string;
}
export default function MessageModal({
  show,
  onClose,
  title,
  description,
  detail,
  action,
  'data-testid': dataTestId,
}: MessageModalProps) {
  const [showStatus, setShowStatus] = useState(show);

  const rootRef = useRef<HTMLDivElement>(null);
  const contentRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (show) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
    document.addEventListener('click', handleClick);
    return () => {
      document.removeEventListener('click', handleClick);
      document.body.style.overflow = 'unset';
    };
    function handleClick(e: MouseEvent) {
      if (rootRef && rootRef.current && contentRef && contentRef.current) {
        const root = rootRef.current;
        const content = contentRef.current;
        if (root.contains(e.target as Node) && !content.contains(e.target as Node)) {
          onClose();
        }
      }
    }
  }, [show]);

  useEffect(() => {
    setShowStatus(show);
  }, [show]);

  return (
    <>
      <div className={showStatus ? styles.loaderWrapper : styles.displayNone} ref={rootRef}>
        <div className={styles.modalRoot} ref={contentRef} data-testid={dataTestId}>
          <div className={styles.title}>{title}</div>
          <div className={styles.mainContainer}>
            <div className={styles.descContainer}>
              {description.split('\n').map((str, index) => (
                <React.Fragment key={index}>
                  {str}
                  <br />
                </React.Fragment>
              ))}
            </div>
            <div className={styles.detailContainer}>
              {detail?.split('\n').map((str, index) => (
                <React.Fragment key={index}>
                  {str}
                  <br />
                </React.Fragment>
              ))}
            </div>
          </div>
          <div className={styles.btnContainer}>
            <ActionButton
              content='閉じる'
              type='dark'
              className={styles.closeBtn}
              action={action}
              data-testid='close-message-modal'
            />
          </div>
        </div>
      </div>
    </>
  );
}
